<div class="columns">
  <div class="column is-2"></div>
  <div class="column">
    <div class="card has-round-border"
         style="box-shadow: 0px 4px 5px 2px rgba(0, 0, 0, 0.3); padding: 5px;margin: auto">
      <form [formGroup]="userForm">
        <div class="title is-4 is-uppercase has-text-centered is-bold"
             style="color: #35566E; padding-top: 10px; margin-bottom: 20px">Registrieren
        </div>
        <app-notification *ngIf="errorMessage" content="{{errorMessage}}" display="true" error="true"
                          timeOut="0"></app-notification>
        <div style="display: flex; align-items: center; flex-direction: column">
          <div class="control" id="gener" style="display: flex; justify-content: start; width: 90%">
            <label class="radio">
              <input formControlName="title" name="title" type="radio" value="Herr"/>
              Herr
            </label>
            <label class="radio">
              <input formControlName="title" name="title" type="radio" value="Frau"/>
              Frau
            </label>
          </div>

          <input [ngClass]="{'has-error': hasError(userForm.get('firstname'))}" class="login border-input form-input" formControlName="firstname" placeholder="Vorname"
                 type="text"/>
          <input [ngClass]="{'has-error':  hasError(userForm.get('lastname'))}" class=" login border-input form-input" formControlName="lastname" placeholder="Nachname"
                 type="text"/>

          <input [ngClass]="{'has-error':  hasError(userForm.get('mail'))}" class="login border-input form-input" formControlName="mail" placeholder="E-Mail Adresse"
                 type="email"/>

          <input [ngClass]="{'has-error':  hasError(userForm.get('password'))}" class="login border-input form-input" formControlName="password" id="password"
                 placeholder="Passwort"
                 type="password"/>

          <p style="font-size: 9px">
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('minlength') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">8 Zeichen</span>
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasNumber') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">Zahl</span>
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasBigLetter') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">Großbuchstaben</span>
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasSmallLetter') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">Kleinbuchstaben</span>
            <span [ngStyle]="userForm.controls['password'].hasError('required') || userForm.controls['password'].hasError('hasSpecialCharacter') ? {'color':'black'} : {'color':'green'}"
                  class="mr-2">Sonderzeichen</span>
          </p>

          <input [ngClass]="{'has-error': userForm.controls['passwordConfirm'].hasError('NoPassswordMatch')}" class="login border-input form-input" formControlName="passwordConfirm"
                 placeholder="Passwort Wiederholen"
                 type="password"/>

          <input [ngClass]="{'has-error':  hasError(userForm.get('company'))}" class=" login border-input form-input" formControlName="company" placeholder="Firma"
                 type="text"/>

          <div style="display: inline-flex; width: 90%">
            <input [ngClass]="{'has-error':  hasError(userForm.get('street'))}" class=" login border-input form-input" formControlName="street"
                   placeholder="Straße" style="width: 80%; margin-right: 5%"
                   type="text"/>
            <input [ngClass]="{'has-error':  hasError(userForm.get('houseNumber'))}" class=" login border-input form-input " formControlName="houseNumber" placeholder="Nr"
                   style="width: 20%"
                   type="text"/>
          </div>

          <div style="display: inline-flex; width: 90%">
            <input [ngClass]="{'has-error':  hasError(userForm.get('zip'))}" class="login border-input form-input" formControlName="zip" id="zip"
                   placeholder="PLZ" style="width: 20%"
                   type="text"/>
            <input [ngClass]="{'has-error':  hasError(userForm.get('town'))}" class=" login border-input form-input" formControlName="town" id="city"
                   placeholder="Stadt" style="width: 80%; margin-left: 5%"
                   type="text"/>
          </div>
          <div class="is-bold has-text-left" style="width: 90%">
            <p>Rechnungsempfänger</p>
            <div>
              <input type="checkbox" (change)="updateBillingAddress()" [checked]="showBilling"/><label class="is-darkblue"> Rechnungsempfänger entspricht Personendaten</label>
            </div>
          </div>
          <div formGroupName="billingAddress" class="has-text-centered">
            <input [ngClass]="{'has-error':  hasError(userForm.get('billingAddress.recipient'))}" class="login border-input form-input" formControlName="recipient"
                   id="billing-address-recipient"
                   placeholder="Name" type="text">
            <input [ngClass]="{'has-error':  hasError(userForm.get('billingAddress.company'))}" class="login border-input form-input" formControlName="company"
                   id="billing-address-company"
                   placeholder="Firma" type="text">
            <input [ngClass]="{'has-error':  hasError(userForm.get('billingAddress.street'))}" class="login border-input form-input" formControlName="street"
                   id="billing-address-street"
                   placeholder="Straße" type="text">

            <div style="display: inline-flex; width: 90%">
              <input [ngClass]="{'has-error':  hasError(userForm.get('billingAddress.zip'))}" class="login border-input form-input" formControlName="zip" id="billing-address-zip"
                     placeholder="PLZ" type="text" style="width: 20%">
              <input [ngClass]="{'has-error':  hasError(userForm.get('billingAddress.town'))}" class="login border-input form-input" formControlName="town" id="billing-address-town"
                     placeholder="Stadt" type="text" style="width: 80%; margin-left: 5%">
            </div>
          </div>

          <button (click)="doRegister()" class="button buy-button is-size-7 has-round-border"
                  style="height: 40px; width: 90% !important; background-color: #73B1D6 !important; margin-top: 10px">
            <p class="is-bold is-uppercase" style="font-size: 15px">Registrieren</p>
          </button>

          <div class="mt-3">
            <a routerLink="/login" style="color: #73b1D6;">Bereits registriert? Jetzt anmelden</a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="column is-2"></div>
</div>

